import r from "../../../temp-lib/config/index.js";
import s from "../../../temp-lib/hooks/json/useReactQueryFetchJson.js";
import * as i from "ramda";
const c = (e) => {
  const {
    fetchNow: o
  } = e || {};
  return s({
    fetchNow: o,
    path: r.JSON_FILE_NAME.VIP_LEVELS,
    deserialize: (t) => i.isNotNil(t) ? t : []
  });
};
export {
  c as default
};
//# sourceMappingURL=useFetchVipLevelsJson.js.map
